import { createSelector } from "@reduxjs/toolkit";

export const newMessagesCountSelector = createSelector<[(state: LSStore.State) => LSStore.IHeaderMenuCountersViewModel], number>(state => state.headerMenuCounters.value, x => x.newMessagesCount ?? 0);
